<template>
  <v-card>
    <v-card-title>
      Collection Info
      <v-spacer />
      <v-btn
        color="success"
        icon
        @click.stop="refresh"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <pre>
{{ collection }}
      </pre>
    </v-card-text>
  </v-card>
</template>
<script>
import { getCollection } from '@/utils/collections'

export default {
  props: {
    activeCollection: null
  },
  computed: {
    collection: {
      get() {
        return this.activeCollection
      },
      set(activeCollection) {
        this.$emit('update:activeCollection', activeCollection)
      }
    }
  },

  methods: {
    refresh: function() {
      const component = this
      if (this.activeCollection) {
        getCollection(this.activeCollection.id).then(response => {
          component.collection = response.data;
        })
      }
    }
  }
}
</script>
